/**
 * AI Services rafactored
 */

import api from './api-wrapper';

const AI_BASE = '/api/v3/ai';

/**
 * Helper to extract response when it is needed
 */
const unwrapResponse = (response) => response?.response ?? response;

/**
 * Factory to create standard CRUD services
 */
const createService = (endpoint) => ({
  get: (params = {}) => api.get(`${AI_BASE}${endpoint}`, { params }),
  create: (data) => api.post(`${AI_BASE}${endpoint}`, data),
  update: (id, data) => api.patch(`${AI_BASE}${endpoint}${id}/`, data),
  delete: (id) => api.delete(`${AI_BASE}${endpoint}${id}/`),
});

// Text Generation
export const createDescription = (data) => api.post(`${AI_BASE}/create-description/`, data).then(unwrapResponse);
export const createTitle = (data) => api.post(`${AI_BASE}/title-proposal/`, data).then(unwrapResponse);
export const recentlyUsed = (data) => api.post(`${AI_BASE}/recently-used/`, data);

// Image Generation  
export const createImage = (data) => api.post(`${AI_BASE}/create-image/`, data).then(unwrapResponse);
export const createVariationsImage = (data) => api.post(`${AI_BASE}/create-variations/`, data).then(unwrapResponse);

// Chat
export const chat = (data) => api.post(`${AI_BASE}/chat-gpt/`, data);
export const getConversations = (data) => api.post(`${AI_BASE}/conversations/`, data);
export const editTitleChat = (uuid, data) => api.post(`${AI_BASE}/change-title/${uuid}/`, data);

// Social Texts
export const getSocialTexts = (params = {}, queryParams = {}) => api.get(`${AI_BASE}/get-texts/`, { params, queryParams });
export const generateText = (data) => api.post(`${AI_BASE}/generate-text/`, data);

// Message Actions
export const actionsMessage = (data) => api.post(`${AI_BASE}/actions-message/`, data);
export const exportMessage = (data) => api.post(`${AI_BASE}/export/message/`, data, { config: { responseType: 'blob' } });

// Assistants
export const getAssistants = (params = {}, isPublic) => {
  const endpoint = isPublic === false ? '/private-person-assistant/' : '/person-assistant/';
  return api.get(`${AI_BASE}${endpoint}`, { params });
};

const assistantService = createService('/person-assistant/');
export const activateAssistant = (data) => api.post(`${AI_BASE}/activate-assistant/`, data);
export const createAssistant = assistantService.create;
export const updateAssistant = assistantService.update;
export const deleteAssistant = assistantService.delete;

// Pricing & Credits
export const getPriceActions = () => api.get(`${AI_BASE}/price-actions/`);
export const getCredits = () => api.get(`${AI_BASE}/credits/`);

// Settings
export const getSettings = () => api.get(`${AI_BASE}/settings/`);
export const updateSettings = (data) => api.post(`${AI_BASE}/settings/`, data);

// Favorites
export const getFavorites = () => api.get(`${AI_BASE}/favorites/`);
export const toggleFavorite = (data) => api.post(`${AI_BASE}/favorites/`, data);
